import React, { useEffect, useRef, useState } from "react";

const StrokeTextAnimation = ({ text, fontSize = 70 }) => {
  const strokeRef = useRef(null);
  const [filled, setFilled] = useState(false);

  useEffect(() => {
    const el = strokeRef.current;

    if (!el) return;

    const length = el.getComputedTextLength();

    el.style.strokeDasharray = length;
    el.style.strokeDashoffset = length;

    setFilled(false);

    const frame = requestAnimationFrame(() => {
      el.style.transition =
        "stroke-dashoffset 1.6s cubic-bezier(0.65, 0, 0.35, 1)";
      el.style.strokeDashoffset = "0";
    });

    const handleTransitionEnd = () => {
      setFilled(true);
    };

    el.addEventListener("transitionend", handleTransitionEnd);

    return () => {
      cancelAnimationFrame(frame);
      el.removeEventListener("transitionend", handleTransitionEnd);
    };
  }, [text]);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 0,
        margin: 0,
      }}
    >
      <svg
        className=""
        viewBox="0 0 600 75"
        preserveAspectRatio="xMidYMid meet"
        style={{
          width: "100%",
          height: "clamp(55px, 9vw, 85px)",
          display: "block",
          overflow: "visible",
          padding: 0,
          margin: 0,
        }}
      >
        <defs>
          <linearGradient
            id="railSetuTextGradient"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor="#ffffff" />
            <stop offset="50%" stopColor="#e9f4ff" />
            <stop offset="100%" stopColor="#b9dcff" />
          </linearGradient>

          <filter
            id="railSetuGlow"
            x="-30%"
            y="-30%"
            width="160%"
            height="160%"
          >
            <feGaussianBlur stdDeviation="2.5" result="blur" />

            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        {/* Final filled text */}
        <text
          x="50%"
          y="50%"
          dominantBaseline="middle"
          textAnchor="middle"
          fontSize={fontSize}
          fontWeight="800"
          fontFamily="Arial, Helvetica, sans-serif"
          fill="url(#railSetuTextGradient)"
          filter="url(#railSetuGlow)"
          style={{
            opacity: filled ? 1 : 0,
            transition: "opacity 0.6s ease",
          }}
        >
          {text}
        </text>

        {/* Animated stroke */}
        <text
          ref={strokeRef}
          x="50%"
          y="50%"
          dominantBaseline="middle"
          textAnchor="middle"
          fontSize={fontSize}
          fontWeight="800"
          fontFamily="Arial, Helvetica, sans-serif"
          fill="none"
          stroke="#ffffff"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{
            filter: "drop-shadow(0 0 5px rgba(255,255,255,0.35))",
          }}
        >
          {text}
        </text>
      </svg>
    </div>
  );
};

export default StrokeTextAnimation;
